<template>
  <div class="loginRedirect" v-show="show">
    <iframe :src="iframeSrc[$route.query.from][$route.query.run]" frameborder="0" hidden></iframe>
  </div>
</template>

<script>
// @ is an alias to /src
import * as API_USER from '@/api/user'

export default {
  name: 'LoginRedirect',
  components: {

  },
  computed: {

  },
  data() {
    return {
      accessOrigin: [
        /* 本地商城 */
        'http://192.168.2.99:3000',
        /* 测试商城 */
        'http://47.88.223.5:5000',
        /* 预发布商城 */
        'http://rel.egc56.com',
        /* 正式商城 */
        'https://mall.egc56.com',

        /* 本地集运 */
        'http://192.168.2.99:82',
        /* 本地集运 */
        'https://192.168.2.99',
        /* 测试集运 */
        'https://test.asiajy.com',
        /* 测试集运 */
        'http://test.asiajy.com',
        /* 预发布集运 */
        'http://rel.asiajy.com',
        /* 正式集运 */
        'https://egc56.com',
        /* 正式集运 */
        'https://www.egc56.com',

        /* 新集运-本地 */
        'http://192.168.2.99:2333',
        /* 新集运-测试 */
        'http://120.78.209.38:83',
        /* 正式JZF */
        'https://www.jzf56.com'
      ],
      iframeSrc: {
        /* 商城 */
        a5bmall: {
          local: 'http://192.168.2.99:3000/loginA5bPay',
          dev: 'http://47.88.223.5:5000/loginA5bPay',
          rel: 'http://rel.egc56.com/loginA5bPay',
          prod: 'https://mall.egc56.com/loginA5bPay',
        },
        /* 集运 */
        asiajy: {
          local: 'https://192.168.2.99/index/auth_login/login',
          dev: 'https://test.asiajy.com/index/auth_login/login',
          rel: 'http://rel.asiajy.com/index/auth_login/login',
          prod: 'https://www.asiajy.com/index/auth_login/login',
        },
        /* 新集运 */
        newasiajy: {
          local: 'http://192.168.2.99:2333/AuthLogin',
          dev: 'http://120.78.209.38:83/AuthLogin',
          rel: 'http://rel.asiajy.com/AuthLogin',
          prod: 'https://www.egc56.com/AuthLogin',
        },
        /* JZF */
        jzfjiyun: {
          local: 'http://192.168.2.99:2333/AuthLogin',
          dev: 'http://120.78.209.38:83/AuthLogin',
          rel: 'http://rel.jzf56.com/AuthLogin',
          prod: 'https://www.jzf56.com/AuthLogin',
        }
        /* 代购 */
        /* 直播 */
      },
      show: 0,
      listenEvent: ''
    }
  },
  async mounted() {
    // console.log(this.iframeSrc[this.$route.query.from][this.$route.query.run])
    // console.log(this.iframeSrc,this.$route.query.from,this.$route.query.run)
  },
  async created() {
    this.setLangCountry()
    await this.$store.dispatch('token', {})
    await this.$store.dispatch('user', {})
    this.show = 1
    this.listen()
  },
  methods: {
    /* 接收iframe postthis.$message */
    listen() {
      window.addEventListener('message',(e)=> {
        // console.log(e);
        // console.log(e.data);
        // console.log(e.origin);
        if (!e.data.accessToken) {
          window.open(e.data.failBack, '_self')
        } else {
          this.ssoLogin(e.data)
          this.listenEvent = e.data
        }
      })

    },
    /* sso登录 */
    ssoLogin(data) {
      let params = {
        token: data.accessToken,
        source: this.$route.query.from
      }
      API_USER.ssoLogin(params).then(async (res)=> {
        if (res.code == 200) {
          await this.$store.dispatch('token', res.data.token)
          await this.$store.dispatch('user', res.data.user)
          this.$router.push({ path: this.$route.query.to })

          // 设置回调网页
          both.storage.set('authBackUrl', res.data.source)
        }
      },rej=> {
        if(rej.code == 142) {
          // 142 = 已经有绑定支付账号了
          this.$messageBox.alert(rej.msg, this.pc_lang.Login_failed, {
            type: 'error',
            callback: ()=> {
              this.$router.push({ name: 'Index' })
            }
          })
        } else {
          this.$messageBox.alert(rej.msg, this.pc_lang.Login_failed, {
            type: 'error',
            callback: ()=> {
              window.open(this.listenEvent.failBack,"_self")
            }
          })
        }
        console.log(rej)
      })
    },
    // 接收语言参数
    setLangCountry() {
      let lang = this.$route.query.lang
      if(!!lang) {
        this.$store.dispatch('langCountry', lang)
      }
    }
  }
}
</script>
<style lang="scss" scoped>

</style>